import { LiquidityBreakdownCard } from "./LiquidityBreakdownCard";
import { LiquidityDroplet } from "./LiquidityDroplet";

import { OptionalTooltip, Row } from "@/components";

import { liquidity as liquidityUtils } from "@/lib/liquidity";
import { JobLiquidity, JobLiquidityBreakdown } from "@/types";

// Droplet gauge for a job's market liquidity. With showGuidance, hovering
// opens the breakdown card (tier guidance plus the market evidence behind
// it); without it, a plain one-line label — list surfaces that only carry
// the level.
export const DashboardLiquidityCell = ({
  breakdown,
  liquidity,
  showGuidance = false,
}: {
  breakdown?: JobLiquidityBreakdown | null;
  liquidity?: JobLiquidity | null;
  showGuidance?: boolean;
}) => {
  /* Helpers */
  const level = liquidity ?? JobLiquidity.UNKNOWN;

  /* Render */
  const renderTooltipText = () => {
    if (!showGuidance) return `${liquidityUtils.label(level)} liquidity`;

    return <LiquidityBreakdownCard breakdown={breakdown} level={level} />;
  };

  const render = () => (
    <OptionalTooltip
      contentClassName={showGuidance ? "w-80 whitespace-normal p-0" : ""}
      text={renderTooltipText()}
      trackingLabel="Dashboard liquidity tooltip"
    >
      <Row className="w-fit items-center">
        <LiquidityDroplet level={level} />
      </Row>
    </OptionalTooltip>
  );

  return render();
};
